import React from 'react'
import classes from './pose-img.module.sass'

const FourPoseGrid = ({ items }) => {
  const half = Math.ceil(items.length / 2)

  const firstHalf = items.slice(0, half)
  const secondHalf = items.slice(-half)

  return (
    <div className={classes.poses4}>
      <div>
        {firstHalf}
      </div>
      <div>
        {secondHalf}
      </div>
    </div>
  )
}

export default FourPoseGrid
